import React, { Component } from 'react';
import './researchSoftwareMinimalDatePicker.css';

function range(start, end) {
  return [...Array(end - start + 1).keys()].map(n => start + n);
}

function DateOption(props) {
  let label = (Math.trunc(props.value / 10) > 0)
            ? props.value
            : `0${props.value}`;
  return <option value={label}>{label}</option>;
}

function parseTimestamp(stamp) {
  let segments = stamp.toString().split('-');
  if (segments[0] === '' || segments[0] === undefined)
    segments[0] = '1960';
  if (segments[1] === '' || segments[1] === undefined)
    segments[1] = '01';
  if (segments[2] === '' || segments[2] === undefined)
    segments[2] = '01';
  return {
    year: segments[0],
    month: segments[1],
    day: segments[2],
  };
}

export default class ResearchSoftwareMinimalDatePicker extends Component {

  constructor(props) {
    super(props);
    var timestamp = parseTimestamp(this.props.value);
    this.name = props.name;
    this.handleDateChange = this.handleDateChange.bind(this);

    this.state={value: this.props.value,
                day: timestamp.day,
                month: timestamp.month,
                year: timestamp.year};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      var timestamp = parseTimestamp(nextProps.value);
      this.setState({day: timestamp.day,
                     month: timestamp.month,
                     year: timestamp.year,
                     value: nextProps.value});
    }
  }

  handleDateChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      [name]: value
    }, () => { this.setState({value: `${this.state.year}-${this.state.month}-${this.state.day}`});
      this.props.update(this.props.slot, `${this.state.year}-${this.state.month}-${this.state.day}`);
    });
  }

  render() {
    const days = range(1, 31).map(n =>
      <DateOption key={n} value={n} />
    );
    const months = range(1, 12).map(n =>
      <DateOption key={n} value={n} />
    );
    const years = range(1960, 2018).map(n =>
      <DateOption key={n} value={n} />
    );

    return (
      <div className="MinimalDatePicker">
      <div class="prodHeaderTexts">
        {this.props.obligatory === true ? '*' : null}{this.props.heading}
      </div>
        <p>{this.props.subheading} </p>
        <div className="MinimalDatePickerDiv">
        <label htmlFor="day">Tag</label>
        <select name="day" onChange={this.handleDateChange} value={this.state.day}>
          {days}
        </select>

        <label htmlFor="month">Monat</label>
        <select name="month" onChange={this.handleDateChange} value={this.state.month}>
          {months}
        </select>

        <label htmlFor="year">Jahr</label>
        <select name="year" onChange={this.handleDateChange} value={this.state.year}>
          {years}
        </select>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/researchSoftwareMinimalDatePicker.js